import forEach from 'lodash/forEach'
import isEmpty from 'lodash/isEmpty'

export default {
  getSelectionCount: (state) => (table, column) => {
    return state.selections?.[table]?.[column]?.values?.length ?? 0
  },
  tableHasSelections: (state) => (table) => {
    if (!state.selections || !state.selections[table]) return false
    let canary = true
    forEach(state.selections[table], column => {
      if (!isEmpty(column.values)) canary = false
      return canary
    })
    return !canary
  },
  hasSelections: (state) => {
    if (!state.selections) return false
    let canary = true
    forEach(state.selections, table => {
      forEach(table, column => {
        if (!isEmpty(column.values)) canary = false
        return canary
      })
      return canary
    })
    return !canary
  },
  hasRequiredFilters: (state) => {
    let hasRequired = false
    forEach(state.schema, table => {
      forEach(table.filter_columns, column => {
        if (column.required) hasRequired = true
        return !hasRequired
      })
      return !hasRequired
    })
    return hasRequired
  },
  hasMissingRequiredFilters: (state, getters, rootState) => {
    // --- THE SAFEGUARD ---
    // If the current project definitively has no filters, it physically 
    // cannot be missing any required filters. Return false immediately!
    if (rootState.navigation.project?.has_filters === false) {
      return false;
    }
    // ---------------------
    return Object.values(state.schema).some(table => {
      const inapplicabilityList = Array.isArray(state.inapplicability)
      ? state.inapplicability
      : []

      // Filter inapplicable entries for this table
      const tableInapplicability = (Array.isArray(state.inapplicability) ? state.inapplicability : []).filter(f => f.table_name === table.table_name)
      const inapplicableColumns = tableInapplicability.map(f => f.column_name)
      const allColumns = table.filter_columns.map(c => c.column_name)
      return table.filter_columns.some(column => {
        const columnName = column.column_name
        const isRequired = column.required
        const isApplicable = inapplicableColumns.indexOf(columnName) === -1
        let values = []
        if (state.selections[table.table_name] &&
            state.selections[table.table_name][columnName]) {
          values = state.selections[table.table_name][columnName].values || []
        }
        if (isRequired && isApplicable && isEmpty(values)) {
          console.error(
            'Missing required filter:',
            'Column:', columnName,
            'Required:', isRequired,
            'Applicable:', isApplicable,
            'Table:', table.table_name
          )
          return true
        }
        return false
      })
    })
  },
  getMissingRequiredFilters: (state) => {
    let missing = {}
    forEach(state.schema, table => {
      let tempTable = []
      forEach(table.filter_columns, column => {
        const selectionData = state.selections[table.table_name]?.[column.column_name]
        if (column.required && (isEmpty(selectionData) || isEmpty(selectionData.values))) {
          tempTable.push(column.id)
        }
      })
      if (!isEmpty(tempTable)) missing[table.id] = tempTable
    })
    return missing
  },
  getMissingRequiredFilterNames: (state) => {
    let missing = [];

    forEach(state.schema, table => {
      forEach(table.filter_columns, column => {
        const selected = state.selections[table.table_name]?.[column.column_name]?.values;

        if (column.required && isEmpty(selected)) {
          missing.push(column.label || column.name || column.column_name);
        }
      });
    });

    return missing;
  },
  getLastAppliedFilters: (state) => {
    return state.lastAppliedFilters
  },
  getLastAppliedFiltersFromColumn: (state) => (table, column) => {
    // If the table doesn't exist in lastApplied, return a safe object with empty values
    if (!state.lastAppliedFilters || !state.lastAppliedFilters[table]) {
      return { values: [] } 
    }
    
    // If the specific column doesn't exist, return a safe object with empty values
    const columnData = state.lastAppliedFilters[table][column]
    if (!columnData) {
      return { values: [] }
    }

    // Otherwise return the real data
    return columnData
  }
}
